import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={24}
    height={24}
    stroke="currentColor"
    viewBox="0 0 6.332 6.106"
  >
    <defs>
      <clipPath id="a">
        <path fillRule="evenodd" d="M642 317h57v55h-57z" clipRule="evenodd" />
      </clipPath>
    </defs>
    <g
      fill="none"
      strokeLinecap="round"
      strokeMiterlimit={8}
      strokeWidth={7}
      clipPath="url(#a)"
      transform="matrix(.11307 0 0 .11307 -72.706 -35.957)"
    >
      <path d="M679.5 321.5h16.25M646.5 333.5H674M668.5 350.5h22.75M655.5 368.5h9.813M687.5 368.5h4.125" />
    </g>
  </svg>
);